<template lang="pug">
  r-table(
    :no-actions="!$can('VIEW_DETAIL_FINANCE_CUSTOMER')"
    no-remove
    remind-key='customer-list'
    v-bind="tableProps"
    @detail="submitShow"
    )
    template( slot='actions' slot-scope='props' )
      r-btn-action( 
        color='success'
        icon
        tooltip='Cartola'
        @click='submitExcel(props)'
        )
          v-icon cloud_download
    template( slot='items' )
      r-dialog(
        content-class='grey lighten-3'
        no-confirm
        title='Descargar cartola de movimientos'
        width='1080'
        v-model='dialog'
        )
          r-form(
          reset-text='cancelar'
          submit-text='descargar'
          v-bind='formProps'
          v-model='formData'
          @submit='submitDownload'
          @reset='dialog = false'
          )
</template>

<script>
//
import { mapActions } from "vuex"
import { RBtnAction, RDialog, RForm, RTable } from "@/components/reusable_components/next"
import CustomerService from "@/services/api/Sale/customer"
import SlCustomerBranchOfficesModel from '@/models/Sale/SlCustomerBranchOffices'
//
import CustomerFilters from "@/views/Sale/SlCustomer/SlCustomerFilters"
import CustomerHeaders from "@/views/Sale/SlCustomer/SlCustomerHeaders"
//
export default {
  name: "customer-list",
  beforeMount() {
    //
    this.setTitle("Clientes")

    //
    CustomerService.appends = [
      ...CustomerService.appends,
      "branch_offices",
      "balance",
      "discount",
      "status",
    ]

    //
    CustomerService.includes = [
      ...CustomerService.includes,
      "sl_customer_account",
      "pch_payment_condition",
      "sl_ground_seller.hr_employee.g_user",
    ]
  },
  components: {
    RBtnAction,
    RDialog,
    RTable,
    RForm,
  },
  computed: {
    formProps() {
      return {
        fields: [
          {
            name: '_',
            type: 'card-title-section',
            flex: {
              xs12: true,
            },
            props: {
              cardProps: {
                color: 'info elevation-0 mb-3',
                dark: true,
              },
              title: 'Elija una sucursal del cliente para generar la cartola de movimientos (o todas si tiene mas de una sucursal).',
            },
          },
          {
            name: 'sl_customer_branch_office_id',
            type: 'select',
            flex: {
              xs12: true,
            },
            props: {
              label: 'Sucursal',
              itemText: 'address',
              itemValue: 'id',
              items: this.selected.branch_offices,
            }
          }
        ],
      }
    },
    tableProps() {
      return {
        filters: CustomerFilters,
        headers: CustomerHeaders,
        service: CustomerService,
      }
    },
  },
  data() {
    return{
      dialog: false,
      formData: {},
      selected: {
        branch_offices: [],
      },
    }
  },
  methods: {
    submitShow(event) {
      this.$router.push({ name: "customer-update", params: { id: event.item.id } })
    },
    submitExcel(event) {
      this.dialog = true
      this.selected = event.item
      this.selected.branch_offices = event.item.branch_offices.slice()
      if(this.selected.branch_offices) {
        this.selected.branch_offices.push({
          id: '',
          address: 'Todas',
        })
      }
    },
    submitDownload(event) {
      this.selected.printReceivable(event.sl_customer_branch_office_id)
    },
  },
  beforeRouteEnter(to, from, next) {
    next(ctx => {
      if (!ctx.$can("VIEW_ALL_FINANCE_CUSTOMER")) ctx.$router.push("/")
    })
  },
}
</script>